import { render, staticRenderFns } from "./_message.vue?vue&type=template&id=04a5e39e&lang=pug&"
import script from "./_message.vue?vue&type=script&lang=js&"
export * from "./_message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports